var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.616 12l4.842 4.843a1.85 1.85 0 01-2.615 2.615L12 14.616l-4.843 4.842a1.85 1.85 0 01-2.615-2.615L9.384 12 4.542 7.157a1.85 1.85 0 112.615-2.615L12 9.384l4.843-4.842a1.85 1.85 0 112.615 2.615L14.616 12z"
  })));
}
export default SvgCross;